import { render } from "./PostEditor.vue?vue&type=template&id=048d8a78"
import script from "./PostEditor.vue?vue&type=script&lang=js"
export * from "./PostEditor.vue?vue&type=script&lang=js"
script.render = render

export default script